export default "__VITE_ASSET__Bxs5iGl4__"